var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "上传数据",
            visible: _vm.visible,
            "close-on-click-model": false,
            "append-to-body": "",
            width: `${900}px`,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
            close: _vm.dialogClose,
          },
        },
        [
          _c(
            "div",
            { staticClass: "search_group" },
            [
              _c("el-input", {
                staticStyle: { width: "220px" },
                attrs: {
                  size: "small",
                  clearable: "",
                  placeholder: "请输入项目名称",
                },
                model: {
                  value: _vm.formChild.search,
                  callback: function ($$v) {
                    _vm.$set(_vm.formChild, "search", $$v)
                  },
                  expression: "formChild.search",
                },
              }),
              _c(
                "el-button",
                {
                  attrs: {
                    icon: "el-icon-search",
                    size: "small",
                    type: "success",
                  },
                  on: { click: _vm.getList },
                },
                [_vm._v("查询")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    icon: "el-icon-upload",
                    size: "small",
                    type: "primary",
                  },
                  on: {
                    click: function ($event) {
                      _vm.showUploadDialog = true
                    },
                  },
                },
                [_vm._v("上传")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    icon: "el-icon-delete",
                    size: "small",
                    type: "danger",
                  },
                  on: { click: _vm.deleteUploadData },
                },
                [_vm._v("删除")]
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              attrs: {
                "max-height": _vm.tableHeight,
                "element-loading-text": "加载中",
                border: "",
                data: _vm.tableData,
              },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: { align: "center", type: "selection", width: "55" },
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  fixed: "",
                  prop: "orderNo",
                  label: "项目编号",
                  width: "200",
                },
              }),
              _c("el-table-column", {
                attrs: { align: "left", label: "项目名称", width: "200" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(scope.row.parentId > 0 ? "【子项目】" : "") +
                              _vm._s(scope.row.orderName)
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "left", label: "原始订单" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.downloadOrgin(scope.row)
                              },
                            },
                          },
                          [_vm._v(_vm._s(scope.row.sfileName))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "table_pagination" },
            [
              _c("el-pagination", {
                staticClass: "app-pagination",
                attrs: {
                  background: "",
                  "current-page": _vm.pageNo,
                  "page-sizes": _vm.pageSizeArr,
                  "page-size": _vm.pageSize,
                  layout: _vm.paginationLayout,
                  total: _vm.totalEl,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
          _c("uploadDialog", {
            attrs: {
              uploadDialogFlag: _vm.showUploadDialog,
              dataType: _vm.dataType,
              editId: _vm.projectInfo.id,
            },
            on: {
              "update:uploadDialogFlag": function ($event) {
                _vm.showUploadDialog = $event
              },
              "update:upload-dialog-flag": function ($event) {
                _vm.showUploadDialog = $event
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }